<h2 mat-dialog-title class="dialog-title">
  Business Rule on property {{ data.propertyName }} in group
  {{ data.propertyGroupName }}
</h2>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form">
    <div class="form-row first-row">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Minimum Accuracy</mat-label>
        <input matInput type="number" formControlName="accuracy" />
      </mat-form-field>

      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="unit">
          <mat-option *ngFor="let u of units" [value]="u">{{ u }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Accuracy Property</mat-label>
        <mat-select formControlName="accuracyProperty">
          <mat-option *ngFor="let p of accuracyProperties" [value]="p">{{
            p
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row second-row">
      <mat-form-field
        class="underline-only narrow-field"
        appearance="fill"
        style="flex: 1"
      >
        <mat-label>Custom validation pattern</mat-label>
        <input matInput type="text" formControlName="customPattern" />
      </mat-form-field>

      <button mat-icon-button matTooltip="Tooltip" style="margin-left: 8px">
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>

    <div class="form-row" style="margin-top: 16px; width:70%;">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Select business rules</mat-label>
        <mat-select formControlName="businessRule">
          <mat-option *ngFor="let rule of businessRules" [value]="rule">{{
            rule
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="form-row"
      style="margin-top: 16px; width: 70%; flex-direction: column"
    >
      <mat-radio-group formControlName="mode" class="vertical-radio">
        <mat-radio-button value="Assert">Assert</mat-radio-button>
        <mat-radio-button value="Report">Report</mat-radio-button>
      </mat-radio-group>
    </div>
  
    <div class="form-row" style="margin-top: 16px; width: 70%;">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Business Rule Description</mat-label>
        <textarea
          matInput
          formControlName="businessRuleDescription"
          rows="4"
          placeholder="Enter the Schematron rule here..."
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<h2 class="dialog-subtitle thin-italic">
  Note: these business rule applies to this property for all uses of the same
  group, not only to the current feature. The group
  {{ data.propertyGroupName }} is used in the following features:
  DesignatedPoint
</h2>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-raised-button color="primary" (click)="onClose()">Save</button>
  <button mat-raised-button color="primary" (click)="onLock()">Cancel</button>
</mat-dialog-actions>
